import { Entity, formatTicker } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { TruncateTooltip } from '~/components/truncate-tooltip/TruncateTooltip';
import { MAX_TICKER_DISPLAY_LENGTH } from '~/stores/use-watchlist/constants';

import * as S from './CompanyNameCell.styles';

export const CompanyNameCell = ({
  entity,
  showAlertIcon = false,
}: {
  entity: Entity;
  showAlertIcon?: boolean;
}) => {
  const { t } = useTranslation('common');

  if (!entity.id) {
    return (
      <S.StyledTextNA data-testid="table-cell-empty-value" $useDash={false}>
        {t('common:table.na')}
      </S.StyledTextNA>
    );
  }

  return (
    <S.Root>
      <S.FlexRowWrapper>
        <S.IconsContainer>
          <AssetLogoContainer entity={entity} size={32} />
          {showAlertIcon && (
            <S.IconContainer>
              <S.StyledIcon
                iconName="ExclamationCircle"
                fillColor="var(--icon-critical)"
                strokeColor="var(--background-soft)"
                size={16}
              />
            </S.IconContainer>
          )}
        </S.IconsContainer>
        <S.CompanyNameContainer>
          <TruncateTooltip
            text={entity.name}
            atLength={MAX_TICKER_DISPLAY_LENGTH}
          />
          <S.Tag>{formatTicker(entity)}</S.Tag>
        </S.CompanyNameContainer>
      </S.FlexRowWrapper>
    </S.Root>
  );
};
